// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'e-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss'],
  imports: [NgClass],
})
export class ContainerComponent {
  @Input() full = false;
}
